import React from 'react';
import { sortBy } from 'lodash';
import { useSelector } from 'react-redux';

/**
 * Use Asset-type Makes Hook
 */
export default (typeId: number) => {
  const { typesList } = useSelector((state) => state);

  const next = React.useMemo(() => {
    if (typeId) {
      const { makes, makeTypes } = typesList;
      const makeIds = makeTypes.data
        .filter((item) => item.typeId === typeId)
        .map((item) => item.makeId)
      ;
      const next = makes.data.filter(({ id }) => makeIds.includes(id));
      return sortBy(next, (item) => item.name);
    }
    return [];
  }, [typeId, typesList]);

  return next;
};
